// src/components/report/SummaryCards.js
import React from 'react';

const SummaryCard = ({ label, value, unit = '' }) => (
  <div className="bg-white rounded-xl p-6 shadow-lg flex flex-col items-center">
    <div className="text-gray-600 mb-3 text-center">{label}</div>
    <div className="text-2xl font-bold text-[#234363] ltr text-center">
      {value}
    </div>
    {unit && (
      <div className="text-sm text-gray-600 mt-1">
        {unit}
      </div>
    )}
  </div>
);

const SummaryCards = ({ metrics, purchaseMetrics }) => {
  const total_gold = purchaseMetrics?.total_shares_acquired || 0;
  const current_gold = metrics?.goldHoldings?.current || 0;
  const redeemed_gold = metrics?.goldHoldings?.redeemed || 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      <SummaryCard 
        label="فلوسك زادت"
        value={(metrics?.roiPercentage || 0).toFixed(1)}
        unit="%"
      />
      <SummaryCard 
        label="رصيدك الحالي"
        value={(current_gold).toFixed(3)}
        unit="جرام"
      />
      <SummaryCard 
        label="أشتريت"
        value={(total_gold / 1000).toFixed(3)}
        unit="جرام"
      />
      <SummaryCard 
        label="حوشت"
        value={(metrics?.totalInvested || 0).toLocaleString()}
        unit="جنيه"
      />
      <SummaryCard 
        label="قيمتهم حاليا"
        value={(metrics?.currentValue || 0).toLocaleString()}
        unit="جنيه"
      />
      <SummaryCard 
    label="استلمت"
    value={(redeemed_gold).toFixed(3)}
    unit={redeemed_gold > 0 ? "جرام" : "في انتظار سبيكتك الأولى"}
/>
    </div>
  );
};

export default SummaryCards;